import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import KobooDialog from '../Layout/KobooDialog.jsx';
import { putStand } from '../../store/stands/actions';
import stylesDefault from '../../constants/stylesDefault';
import MqttApiService from '../../services/api/MqttApiService';

const MQTT_COMMAND_UNLOCK = 5;

const standState = state => {
  let label;
  switch (state) {
    case 0:
      label = 'Verrouillée';
      break;
    default:
      label = 'Deverrouillée';
  }
  return (
    <TableCell>{label}</TableCell>
  );
};

const INITIAL_STATE = {
  dialog: {
    open: false,
    item: '',
  },
  sendingStandId: null
};

export class StandRow extends Component {
  static propTypes = {
    container: PropTypes.object.isRequired,
    stand: PropTypes.object.isRequired,
    stands: PropTypes.array.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = { ...INITIAL_STATE };
  }

  // Handler

  handleClose = () => {
    this.setState({ ...INITIAL_STATE });
  };

  handleClickOpen = () => {
    this.setState({ dialog: {
        ...this.state.dialog,
        open: true,

      }});
  };

  handleClickEditStand = (event) => {
    this.handleClose();
    this.props.putStand(
      this.props.authUser.ma,
      this.props.stand.id,
      {
        site_id: this.props.stand.site_id,
        number: Number(this.state.dialog.item)
      },
    );
    event.preventDefault();
  };

  handleClickUnlock = (event) => {
    this.setState({ sendingStandId: this.props.stand.id});
    MqttApiService.postEvent(
      this.props.authUser.ma,
      {
        containerNumber:this.props.container.number,
        command:MQTT_COMMAND_UNLOCK,
        standNumber:this.props.stand.number
      }
    ).then(() => {
      this.setState({ sendingStandId: null});
    });
    event.preventDefault();
  };

  // Computation

  bikeTooltip = bike => {
    let bikeTitle = "";
    if (bike.padlock_number) {
      bikeTitle+= "Cadenas : "+bike.padlock_number;
    }
    if (bike.mac_address) {
      bikeTitle+= " - Adresse MAC : "+bike.mac_address;
    }
    if (bike.rfid) {
      bikeTitle+= " - RFID : "+bike.rfid;
    }
    return bikeTitle
  };

  render() {
    const { stand, bike, stands } = this.props;
    const alreadyExistsStandItem = stands.filter(stand =>
      stand.number === Number(this.state.dialog.item)).length > 0;
    return (
      <Tooltip
        title={bike ? this.bikeTooltip(bike) : ''}
      >
        <TableRow
          key={stand.id}
          hover
          tabIndex={-1}>
          <KobooDialog
            id="dialog_edit_stand"
            open={this.state.dialog.open}
            handleClose={this.handleClose}
            dialogTitle={`Voulez-vous modifier la borne numéro ${stand.number} ?`}
            handleCloseCancel={this.handleClose}
            handleCloseOK={event => this.handleClickEditStand(event)}
            textField={<TextField
              value={this.state.dialog.item}
              onChange={event => this.setState({
                dialog: {
                  ...this.state.dialog,
                  item: event.target.value
                }
              })}
              label="Numéro de la borne"
              placeholder="Numéro de la borne"
              helperText={alreadyExistsStandItem ?
                "Cet numéro est déjà utilisé" : ""}
              type="text"
              margin="normal"
              error={alreadyExistsStandItem}

            />}
            cancelText="ANNULER"
            okText="VALIDER"
            disabled={alreadyExistsStandItem}
          />
          <TableCell numeric>{stand.number}</TableCell>
          {standState(stand.state)}
          <TableCell>{bike ? bike.number :
            stand.bike_rfid ?
              'Vélo inconnu (RFID: '+stand.bike_rfid+' )'
              :'Pas de vélo'}</TableCell>
          <TableCell padding="checkbox">
            <Tooltip title="Modifier">
              <IconButton
                id="button_open_dialog"
                onClick={this.handleClickOpen}
              >
                <EditIcon/>
              </IconButton>
            </Tooltip>
            {stand.state === 0 &&
            <Tooltip title="Déverrouiller">
              <IconButton
                id="button_unlock"
                onClick={this.handleClickUnlock}
              >
                <LockOpenIcon/>
                {this.state.sendingStandId &&  this.state.sendingStandId === stand.id &&
                <CircularProgress size={58} style={stylesDefault.fabProgress} />}
              </IconButton>
            </Tooltip>}
          </TableCell>
        </TableRow>
      </Tooltip>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    pending: state.stands.pending,
    sending: state.stands.sending
  };
}

export default connect(mapStateToProps, {putStand})(StandRow)



// WEBPACK FOOTER //
// ./src/components/Stand/StandRow.jsx